<template>
	<information-card>
		<div slot="title" class="tw-py-6">
			<h3 class="tw-text-center text-primary">VALORACIÓN DE PUESTOS</h3>
		</div>
		<div slot="content">
			<div class="tw-py-16">
				<degree-linear-progression-chart
					:factor-degrees-by-factor="factorDegreesByFactor"
				/>
			</div>
		</div>
		<div slot="footer" class="tw-text-center">
			<v-btn
				:disabled="disableCreate"
				class="custom-button"
				color="primary" @click="$emit('createClick')">Crear Valoración</v-btn>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';
import CardHeader from '@/modules/shared/components/ui/Card/CardHeader';
import DegreeLinearProgressionChart
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/DegreeLinearProgressionChart';

export default {
	name: 'DegreesDecriptionNavigation',
	components: { DegreeLinearProgressionChart, CardHeader, InformationCard },
	props: ['factorDegreesByFactor', 'disableCreate'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/DegreesDescriptionNavigation.vue